import React, { useEffect, useState } from "react";
import {
  Button,
  Carousel,
  //  Placeholder
} from "react-bootstrap";
import "../../assets/css/style.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaPlay, FaExternalLinkAlt } from "react-icons/fa";

import API from "../../config/axios";
import { api_paths } from "../../config/api.paths";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

// Ensure the redirect URL has a protocol so it opens as an absolute (external) link
const normalizeRedirectUrl = (url) =>
  /^https?:\/\//i.test(url) ? url : `https://${url}`;

export default function HeroSection({ bannerData, loading }) {
  const [loggedin, setLoggedIn] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [nominationOpen, setNominationOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.USER_DATA);

  useEffect(() => {
    if (user) {
      setLoggedIn(true);
    }
  }, [user]);

  useEffect(() => {
    const checkNominationStatus = async () => {
      try {
        const res = await API.get(api_paths.member.NOMINATION.GET_SETTING);
        const isOpen = res.data?.payload?.result?.isOpen || false;
        setNominationOpen(isOpen);
      } catch (err) {
        console.error("Error checking nomination status:", err);
      }
    };
    checkNominationStatus();
  }, []);

  return (
    <section className="hero-section mb-5 mt-4">
      <div className="text-center hero-intro">
        {/* <span className="hero-badge">Gujarati Samaj of Tampa Bay</span> */}
        <h1 className="hero-title">
          Welcome to Gujarati Samaj of Tampa Bay
          {/* <br /> */}
          {/* of Tampa Bay */}
        </h1>
        <p className="hero-legal f-16 mx-auto" style={{ color: "#418744" }}>
          Gujarati Samaj of Tampa Bay Inc is nonprofit organization recognized
          as tax-exempt under Section 501(c)(3) of the Internal Revenue Code
        </p>
        <p className="hero-sub">
          Gujarati Samaj of Tampa Bay Inc (GSTB) is a vibrant cultural
          organization dedicated to preserving and promoting Gujarati heritage,
          culture, and traditions in the Tampa Bay area.
        </p>

        <div className="d-flex justify-content-center gap-3 flex-wrap align-items-center mt-3">
          {!loggedin && (
            <Button
              className="btn btn-orange btn-event-details w-auto px-4"
              onClick={() => navigate("/membership")}
            >
              Become a Member
            </Button>
          )}
          {nominationOpen && (
            <Button
              className="btn btn-orange btn-event-details w-auto px-4"
              onClick={() => navigate("/nomination")}
            >
              Nomination Registration
            </Button>
          )}
        </div>
      </div>

      <div className="hero-carousel-wrapper mt-4 position-relative">
        {/* decorative shapes behind slider */}
        <div className="hero-shape hero-shape-1" aria-hidden="true" />
        <div className="hero-shape hero-shape-2" aria-hidden="true" />

        {loading ? (
          <Skeleton height={450} borderRadius={12} />
        ) : (
          bannerData &&
          bannerData.length > 0 && (
            <div className="hero-slider-card mx-auto">
              <Carousel
                className="hero-slider"
                indicators={false}
                interval={4500}
                pause="hover"
                prevIcon={<span className="carousel-control-prev-icon" />}
                nextIcon={<span className="carousel-control-next-icon" />}
              >
                {bannerData.map((banner) => (
                  <Carousel.Item key={banner._id}>
                    <div className="banner-media-wrapper position-relative">
                      <img
                        className={`d-block w-100 hero-slide-img${
                          banner.redirect_url ? " cursor-pointer" : ""
                        }`}
                        src={`${IMAGE_BASEURL}${banner.image_path}`}
                        alt={banner?.title}
                        onClick={() => {
                          if (banner.redirect_url) {
                            window.open(
                              normalizeRedirectUrl(banner.redirect_url),
                              "_blank",
                              "noopener,noreferrer",
                            );
                          }
                        }}
                      />
                      {(banner.video_path || banner.video) && (
                        <button
                          className="video-play-overlay-btn"
                          aria-label="Play video"
                          onClick={(e) => {
                            e.stopPropagation();
                            setVideoUrl(
                              banner.video ||
                                `${IMAGE_BASEURL}${banner.video_path}`,
                            );
                          }}
                        >
                          <FaPlay className="video-play-icon" />
                        </button>
                      )}
                      {banner.redirect_url && (
                        <a
                          href={normalizeRedirectUrl(banner.redirect_url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="banner-open-btn"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <FaExternalLinkAlt className="banner-open-icon" /> Open
                        </a>
                      )}
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          )
        )}
      </div>

      {/* Video Fullscreen Modal */}
      {videoUrl && (
        <div
          className="video-fullscreen-overlay"
          onClick={() => setVideoUrl(null)}
        >
          <div
            className="video-fullscreen-inner"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="video-fullscreen-close"
              onClick={() => setVideoUrl(null)}
              aria-label="Close video"
            >
              ✕
            </button>
            <video
              src={videoUrl}
              controls
              autoPlay
              className="video-fullscreen-player"
            />
          </div>
        </div>
      )}
    </section>
  );
}
